const es = {
    "eligibility.step1": "Paso 1 - Elegibilidad",
    "eligibility.planWithYou": "¿Quién estará en el plan contigo?" ,
    "eligibility.enrollingForJustYourself": "Seleccione todo lo que corresponda. Si no selecciona ninguno, se inscribirá solo para usted.",
    "postEnrollment.print": "Imprimir"
}

export default es;